module.exports = __webpack_public_path__ + "img/12_klio_28.3fd9d8fa.jpg";